import { Link } from 'react-router-dom';
import { workspaceModuleStyle, workspaceToneClasses } from './workspace-module-style';

/**
 * The module eyebrow above a workspace card's title, as a link into that module.
 *
 * A workspace card is a summary; the natural next step from one is the module it
 * summarises, and the module name is already the label for exactly that. It is a
 * real anchor so it opens in a new tab on middle-click like any other link.
 */
export function CardModuleLink({
  module,
  href,
  editing = false,
}: {
  module: string;
  href: string;
  /** In edit mode the label is inert — navigating away would discard the draft layout. */
  editing?: boolean;
}) {
  const appearance = workspaceModuleStyle(module);
  const Icon = appearance.icon;
  const content = (
    <>
      <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded ${workspaceToneClasses[appearance.tone]}`}>
        <Icon className="h-3 w-3" aria-hidden="true" />
      </span>
      <span className="truncate">{module}</span>
    </>
  );
  if (editing) {
    return (
      <span className="flex min-w-0 items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
        {content}
      </span>
    );
  }

  return (
    <Link
      to={href}
      // The header doubles as the drag handle in edit mode; stop the press from
      // starting a drag so a click reliably navigates.
      onPointerDown={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      className="flex min-w-0 items-center gap-1.5 rounded-sm text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground transition-colors hover:text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      title={`Go to ${module}`}
    >
      {content}
    </Link>
  );
}
